module.exports = __webpack_public_path__ + "static/media/miniwave-policie-red.c783cfee.svg";